import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { usePlans } from "../PlansContext";
import { SectionWrapper } from "./SectionWrapper";
import { useLiveStreamLimitValues } from "./useLiveStreamLimitValues";

export const LiveStreams = () => {
  const { compareTablePlanFeatures } = usePlans();
  const { professionalHosts, businessHosts, professionalHours, businessHours } =
    useLiveStreamLimitValues();
  if (!compareTablePlanFeatures) return null;

  const FLEXIBLE_VALUE = t("pricing_plans.feature.flexible");

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.live_streams")}>
      <FeatureRow
        title={t("pricing_plans.feature.live_stream_max_spectator_capacity")}
        professional={`${compareTablePlanFeatures.professional?.live_stream_max_spectator_capacity}`}
        enterprise={`${compareTablePlanFeatures.enterprise?.live_stream_max_spectator_capacity}`}
        business={`${compareTablePlanFeatures.business?.live_stream_max_spectator_capacity}`}
        plus={FLEXIBLE_VALUE}
      />
      <FeatureRow
        title={t("pricing_plans.feature.live_room_participants")}
        professional={`${professionalHosts}`}
        business={`${businessHosts}`}
        enterprise={`${compareTablePlanFeatures.enterprise?.live_room_participants_capacity}`}
        plus={FLEXIBLE_VALUE}
      />
      <FeatureRow
        title={t("pricing_plans.feature.live_stream_hosts")}
        professional={`${professionalHosts}`}
        business={`${businessHosts}`}
        enterprise={`${compareTablePlanFeatures.enterprise?.live_stream_max_host_capacity}`}
        plus={FLEXIBLE_VALUE}
      />
      <FeatureRow
        title={t("pricing_plans.feature.live_stream_monthly_stream_hours")}
        professional={`${professionalHours}`}
        business={`${businessHours}`}
        enterprise={`${compareTablePlanFeatures.enterprise?.live_stream_monthly_stream_hours}`}
        plus={FLEXIBLE_VALUE}
      />
    </SectionWrapper>
  );
};
